export default __webpack_public_path__ + "static/media/finance-inactive.fd6cf01e.svg";